export var FETCH_LINE_HEADERS = 'FETCH_LINE_HEADERS';
export var SUCCESS_FETCH_LINE_HEADERS = 'SUCCESS_FETCH_LINE_HEADERS';
export var FAILURE_FETCH_LINE_HEADERS = 'FAILURE_FETCH_LINE_HEADERS';
export var FETCH_LEAGUE_LINE_HEADERS = 'FETCH_LEAGUE_LINE_HEADERS';
export var SUCCESS_FETCH_LEAGUE_LINE_HEADERS = 'SUCCESS_FETCH_LEAGUE_LINE_HEADERS';
export var FAILURE_FETCH_LEAGUE_LINE_HEADERS = 'FAILURE_FETCH_LEAGUE_LINE_HEADERS';
export var FETCH_SPORT_LINE_HEADERS = 'FETCH_SPORT_LINE_HEADERS';
export var SUCCESS_FETCH_SPORT_LINE_HEADERS = 'SUCCESS_FETCH_SPORT_LINE_HEADERS';
export var FAILURE_FETCH_SPORT_LINE_HEADERS = 'FAILURE_FETCH_SPORT_LINE_HEADERS';
export var FETCH_FULL_LINE = 'FETCH_FULL_LINE';
export var SUCCESS_FETCH_FULL_LINE = 'SUCCESS_FETCH_FULL_LINE';
export var FAILURE_FETCH_FULL_LINE = 'FAILURE_FETCH_FULL_LINE';
export var FETCH_PREMATCH_MENU = 'FETCH_PREMATCH_MENU';
export var SUCCESS_FETCH_PREMATCH_MENU = 'SUCCESS_FETCH_PREMATCH_MENU';
export var FAILURE_FETCH_PREMATCH_MENU = 'FAILURE_FETCH_PREMATCH_MENU';
export var CLEAR_LINE = 'CLEAR_LINE';



// WEBPACK FOOTER //
// ./src/actions/lines.js